import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Page/page';
import { css } from '@patternfly/react-styles';
import globalBreakpointXl from '@patternfly/react-tokens/dist/js/global_breakpoint_xl';
import { debounce } from '../../helpers/util';
export var PageLayouts;

(function (PageLayouts) {
  PageLayouts["vertical"] = "vertical";
  PageLayouts["horizontal"] = "horizontal";
})(PageLayouts || (PageLayouts = {}));

var PageContext = React.createContext({});
export var PageContextProvider = PageContext.Provider;
export var PageContextConsumer = PageContext.Consumer;
export var Page =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Page, _React$Component);

  function Page(props) {
    var _this;

    _classCallCheck(this, Page);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Page).call(this, props));

    _this.handleResize = function () {
      var onPageResize = _this.props.onPageResize;
      var windowSize = window.innerWidth; // eslint-disable-next-line radix

      var mobileView = windowSize < Number.parseInt(globalBreakpointXl.value, 10);

      if (onPageResize) {
        onPageResize({
          mobileView: mobileView,
          windowSize: windowSize
        });
      }

      _this.setState({
        mobileView: mobileView
      });
    };

    _this.onNavToggleMobile = function () {
      _this.setState(function (prevState) {
        return {
          mobileIsNavOpen: !prevState.mobileIsNavOpen
        };
      });
    };

    _this.onNavToggleDesktop = function () {
      _this.setState(function (prevState) {
        return {
          desktopIsNavOpen: !prevState.desktopIsNavOpen
        };
      });
    };

    var isManagedSidebar = props.isManagedSidebar,
        defaultManagedSidebarIsOpen = props.defaultManagedSidebarIsOpen;
    var managedSidebarOpen = !isManagedSidebar ? true : defaultManagedSidebarIsOpen;
    _this.state = {
      desktopIsNavOpen: managedSidebarOpen,
      mobileIsNavOpen: false,
      mobileView: false
    };
    return _this;
  }

  _createClass(Page, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          isManagedSidebar = _this$props.isManagedSidebar,
          onPageResize = _this$props.onPageResize;

      if (isManagedSidebar || onPageResize) {
        window.addEventListener('resize', debounce(this.handleResize, 250)); // Initial check if should be shown

        this.handleResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          isManagedSidebar = _this$props2.isManagedSidebar,
          onPageResize = _this$props2.onPageResize;

      if (isManagedSidebar || onPageResize) {
        window.removeEventListener('resize', debounce(this.handleResize, 250));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          breadcrumb = _a.breadcrumb,
          className = _a.className,
          children = _a.children,
          header = _a.header,
          sidebar = _a.sidebar,
          skipToContent = _a.skipToContent,
          role = _a.role,
          mainContainerId = _a.mainContainerId,
          isManagedSidebar = _a.isManagedSidebar,
          defaultManagedSidebarIsOpen = _a.defaultManagedSidebarIsOpen,
          onPageResize = _a.onPageResize,
          mainAriaLabel = _a.mainAriaLabel,
          mainTabIndex = _a.mainTabIndex,
          rest = __rest(_a, ["breadcrumb", "className", "children", "header", "sidebar", "skipToContent", "role", "mainContainerId", "isManagedSidebar", "defaultManagedSidebarIsOpen", "onPageResize", "mainAriaLabel", "mainTabIndex"]);

      var _this$state = this.state,
          mobileView = _this$state.mobileView,
          mobileIsNavOpen = _this$state.mobileIsNavOpen,
          desktopIsNavOpen = _this$state.desktopIsNavOpen;
      var context = {
        isManagedSidebar: isManagedSidebar,
        onNavToggle: mobileView ? this.onNavToggleMobile : this.onNavToggleDesktop,
        isNavOpen: mobileView ? mobileIsNavOpen : desktopIsNavOpen
      };
      return React.createElement(PageContextProvider, {
        value: context
      }, React.createElement("div", Object.assign({}, rest, {
        className: css(styles.page, className)
      }), skipToContent, header, sidebar, React.createElement("main", {
        role: role,
        id: mainContainerId,
        className: css(styles.pageMain),
        tabIndex: mainTabIndex,
        "aria-label": mainAriaLabel
      }, breadcrumb && React.createElement("section", {
        className: css(styles.pageMainBreadcrumb)
      }, breadcrumb), children)));
    }
  }]);

  return Page;
}(React.Component);
Page.defaultProps = {
  isManagedSidebar: false,
  defaultManagedSidebarIsOpen: true,
  onPageResize: function onPageResize() {
    return null;
  },
  mainTabIndex: -1
};